function ConferenceIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width={30}
      height={30}
      viewBox="0 0 512 512"
      {...props}
    >
      {'{" "}'}
      <path
        d="m417.45 295.059-10.006-10.007c2.62-10.792-.275-22.661-8.686-31.073l-6.5-6.5c-12.825-12.826-33.696-12.826-46.524 0-12.855 12.856-12.857 33.666 0 46.523l6.501 6.502c8.274 8.274 20.089 11.35 31.072 8.684l5.007 5.007v48.431c0 9.425 7.641 17.067 17.067 17.067s17.067-7.641 17.067-17.067v-55.5c0-4.526-1.798-8.866-4.998-12.067z"
        style={{
          fill: "#325763",
        }}
      />
      {'{" "}'}
      <path
        d="m241.22 303.65-44.215-76.585h-94.216c-28.184 0-51.114-22.929-51.114-51.114V51.114C51.674 22.928 74.604 0 102.789 0h306.422c28.184 0 51.114 22.928 51.114 51.114v124.839c0 28.184-22.93 51.114-51.114 51.114h-94.216L270.78 303.65c-6.565 11.371-23.005 11.354-29.56 0z"
        style={{
          fill: "#fae8ac",
        }}
      />
      {'{" "}'}
      <path
        d="M409.211 0H256v312.172c5.749.001 11.498-2.838 14.78-8.522l44.215-76.585h94.216c28.184 0 51.114-22.929 51.114-51.114V51.114C460.326 22.928 437.396 0 409.211 0z"
        style={{
          fill: "#f6d86e",
        }}
      />
      {'{" "}{" "}'}
      <path
        d="M366.906 100.943H145.094c-9.425 0-17.067-7.641-17.067-17.067s7.641-17.067 17.067-17.067h221.811c9.425 0 17.067 7.641 17.067 17.067s-7.641 17.067-17.066 17.067z"
        style={{
          fill: "#fbb071",
        }}
      />
      {'{" "}'}
      <path
        d="M366.906 160.258H145.094c-9.425 0-17.067-7.641-17.067-17.067 0-9.425 7.641-17.067 17.067-17.067h221.811c9.425 0 17.067 7.641 17.067 17.067s-7.641 17.067-17.066 17.067z"
        style={{
          fill: "#fbb071",
        }}
      />
      {'{" "}{" "}'}
      <path
        d="M420.56 512H91.44a17.065 17.065 0 0 1-15.774-10.551l-22.699-54.955c-4.636-11.224 3.631-23.583 15.774-23.583h374.517c12.145 0 20.409 12.359 15.774 23.583l-22.699 54.955A17.063 17.063 0 0 1 420.56 512z"
        style={{
          fill: "#16a5d9",
        }}
      />
      {'{" "}'}
      <path
        d="M443.259 422.912H256V512h164.56a17.065 17.065 0 0 0 15.774-10.551l22.699-54.955c4.635-11.222-3.631-23.582-15.774-23.582z"
        style={{
          fill: "#1289b5",
        }}
      />
      {'{" "}'}
      <path
        d="M489.389 457.045H22.611c-9.425 0-17.067-7.641-17.067-17.067v-77.352c0-9.425 7.641-17.067 17.067-17.067h466.778c9.425 0 17.067 7.641 17.067 17.067v77.352c0 9.426-7.642 17.067-17.067 17.067z"
        style={{
          fill: "#4ad0ff",
        }}
      />
      {'{" "}'}
      <path
        d="M489.389 345.56H256v111.485h233.389c9.425 0 17.067-7.641 17.067-17.067v-77.352c0-9.424-7.642-17.066-17.067-17.066z"
        style={{
          fill: "#16a5d9",
        }}
      />
      {'{" "}{" "}'}
      <path
        d="M366.906 66.809H256v34.133h110.906c9.425 0 17.067-7.641 17.067-17.067s-7.642-17.066-17.067-17.066z"
        style={{
          fill: "#ff835d",
        }}
      />
      {'{" "}'}
      <path
        d="M366.906 126.125H256v34.133h110.906c9.425 0 17.067-7.641 17.067-17.067 0-9.425-7.642-17.066-17.067-17.066z"
        style={{
          fill: "#ff835d",
        }}
      />
      {'{" "}{" "}'}
    </svg>
  );
}

export default ConferenceIcon;
